import React, { useState, useEffect } from 'react';
import classes from "./form.module.css";
import { sixYardAxios } from "../../../sixYardAxios";
import InputField from "../../containers/inputField/inputField";
import qs from 'qs';
import PromptMessage from "../../containers/promptMessage/promptMessage";
const Form = (props) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [width, setWidth] = useState(0);
    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [controls, setControls] = useState({
        fullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Full Name" : "الاسم الكامل",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Phone Number" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        message: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter your message" : "أدخل رسالتك",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Message" : "الرسالة",
            valid: false,
            touched: false,
        },
    });
    const handleResize = () => setWidth(window.innerWidth);
    useEffect(() => {
        setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName) => {
        // Check if the control being updated is the phone input
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value: controlName === 'phone' ? event : event.target.value,
                valid: controlName === 'phone' ? checkValidity(event, controls[controlName].validation) : checkValidity(event.target.value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
        let isValid = true;
        for (let inputIdentifier in updatedControls) {
            isValid = updatedControls[inputIdentifier].valid && isValid;
        }
        setIsValid(isValid);
    };
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    const submitHandler = e => {
        e.preventDefault();
        sixYardAxios({
            method: "post",
            url: "/contact",
            data: qs.stringify({
                "name": controls.fullName.value,
                "email": controls.email.value,
                "phone": controls.phone.value.dialCode + controls.phone.value.number,
                "message": controls.message.value
            })
        })
            .then(response => {
                setSuccess(response.data.message);
                clearControls();
                // window.scrollTo({ top: 0, behavior: 'smooth' });
            })
            .catch(error => {
                setError(error.response.data.message);
            });
    };
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            <p className={classes.FormDescription}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Interested in being part of 6 Yard world! Fill up the form and we shall contact you shortly"
                    : "مهتم بأن تكون جزءاً من عالم 6 يارد! املأ النموذج وسنتواصل معك قريباً"}
            </p>
            {form}
            <p className={classes.Prompt}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Please read and agree to our "
                    : "يرجى قراءة والموافقة على "}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Privacy Policy "
                        : "سياسة الخصوصية "}
                </a>
                {parseInt(localStorage.getItem('language')) === 1 ? "and " : "و "}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Terms" : "الشروط"}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "I have read and agreed to terms and conditions and privacy policy"
                        : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                </label>
            </div>
            <div>
                <button type="submit" 
                    className={[classes.submitButton, ((!isTermsChecked && width > 599) || isValid) && classes.Disabled].join(" ")}
                    disabled={(!isTermsChecked && width > 599) || isValid}
                >
                    {parseInt(localStorage.getItem('language')) === 1 ? "SEND" : "إرسال"}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {error && <PromptMessage 
                message={error} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'Oops' : 'عفواً'} 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
            {success && <PromptMessage 
                message={success} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
                successMessage 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={() => setSuccess(false)} 
            />}
        </form>
    )
}
export default Form;